import { createRouter, createWebHistory } from 'vue-router'
import Home from '../pages/Home.vue'
import ProductDetail from '../pages/ProductDetail.vue'
import Recrutment from '../pages/Recrutment.vue'
import AllProductByCat from '../pages/AllProductByCat.vue'
import AllProduct from '../pages/AllProduct.vue'
import Auth from '../pages/Auth.vue'
import Project from '../pages/Project.vue'
import About from '../pages/AboutP.vue'
import Services from '../pages/ServicesP.vue'
import FeedbackP from '../pages/FeedbackP.vue'
import ContactP from '../pages/ContactP.vue'
import PartenaireDetails from '../pages/PartenaireDetails.vue'

const routes = [
  {
    path: '/',
    component: Home,
    meta: { title: 'Mega Hissotto | Climatisation, Froid Industriel & Pompes à Chaleur – Algérie' }
  },
  {
    path: '/product/:identifier',
    component: ProductDetail,
    props: true,
    alias: '/detailproduct/:id',
    meta: { title: 'Produit | Mega Hissotto' }
  },
  {
    path: '/Recrutment',
    component: Recrutment,
    meta: { title: 'Recrutement | Mega Hissotto' }
  },
  {
    path: '/ByCat/:id',
    component: AllProductByCat,
    props: true,
    meta: { title: 'Produits par Catégorie | Mega Hissotto' }
  },
  {
    path: '/Project',
    component: Project,
    meta: { title: 'Nos Réalisations | Mega Hissotto' }
  },
  {
    path: '/Feedback',
    component: FeedbackP,
    meta: { title: 'Avis Clients | Mega Hissotto' }
  },
  {
    path: '/ContactP',
    component: ContactP,
    meta: { title: 'Contact | Mega Hissotto' }
  },
  {
    path: '/Services',
    component: Services,
    meta: { title: 'Nos Services | Mega Hissotto' }
  },
  {
    path: '/Auth',
    component: Auth,
    meta: { title: 'Connexion | Mega Hissotto', noIndex: true }
  },
  {
    path: '/About',
    component: About,
    meta: { title: 'À Propos | Mega Hissotto' }
  },
  {
    path: '/allProduct',
    component: AllProduct,
    meta: { title: 'Tous nos Produits | Mega Hissotto' }
  },
  {
    path: '/PDetails/::slug',
    component: PartenaireDetails,
    meta: { title: 'Partenaire | Mega Hissotto' }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// ===== SEO: Fallback title + noIndex guard =====
router.beforeEach((to) => {
  if (to.meta?.title) {
    document.title = to.meta.title
  }
  // Remove/add noindex for pages that must not be indexed
  let robotsMeta = document.querySelector('meta[name="robots"]')
  if (!robotsMeta) {
    robotsMeta = document.createElement('meta')
    robotsMeta.setAttribute('name', 'robots')
    document.head.appendChild(robotsMeta)
  }
  robotsMeta.setAttribute('content', to.meta?.noIndex ? 'noindex, nofollow' : 'index, follow')
})

export default router